import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';

var BaseService = require('../../service/baseservice');

var emptyCategory = {
      _id: "",
      name: "",
      officialName:"",
      searchTerms:""
    };

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
export default class CategoryEditDialog extends Component {
  state = {
    hasUnsavedChanges: false,
    editedNameOnce: false,
    editedIdOnce: false,
    isNew: true,
    saving: false,
    category: emptyCategory
  };

  componentWillReceiveProps(newProps) {
    this.setState({category: newProps.category,
        saving: false,
        isNew: newProps.category._id === ""});
  }

  handleFormEdit = (state) => {
    state.hasUnsavedChanges = true;
    return state;
  }

  handleIdEdit = (event) => {
    var state = this.state;
    state.category._id = event.target.value;
    state.editedIdOnce = true;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleNameEdit = (event) => {
    var state = this.state;
    state.category.name = event.target.value;
    state.editedNameOnce = true;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleFriendlyNameEdit = (event) => {
    var state = this.state;
    state.category.friendlyName = event.target.value;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  handleSearchTermsEdit = (event) => {
    var state = this.state;
    state.category.searchTerms = event.target.value;
    state = this.handleFormEdit(state);
    this.setState(state);
  }

  notEditedActions() {
    var cancelTitle = this.props.category._id === "" ? "Peruuta" : "Sulje";
    return [
      <FlatButton
        label={cancelTitle}
        onTouchTap={this.props.handleClose}
      />
    ];
  }

  savingActions() {
    return [<CircularProgress size={30} thickness={2} style={{marginRight:'60px'}} />];
  }

  editedActions() {
    var saveTitle = this.state.isNew ? "Luo toimiala" : "Tallenna muutokset";
    var cancelTitle = this.state.isNew ? "Peruuta" : "Peruuta muutokset";
    return [
      <FlatButton
        label={cancelTitle}
        onTouchTap={this.props.handleClose}
      />,
      <FlatButton
        label={saveTitle}
        primary={true}
        onTouchTap={() => this.handleSaveChanges()}
        disabled={!this.isValidForm()}
      />
    ];
  }

  handleSaveChanges() {
    this.setState({saving: true});
    if (this.state.isNew) {
        BaseService.addCategory(this.state.category).then(category => {
          this.setState({category:emptyCategory});
          this.props.handleClose();
        });
    } else {
      BaseService.editCategory(this.state.category).then(category => {
        this.setState({category:emptyCategory});
        this.props.handleClose();
      });
    }
  }

  isValidName() {
    return this.state.category.name.length > 0;
  }

  isValidId() {
    return String(this.state.category._id).length > 0;
  }

  isValidForm() {
    return this.isValidId() && this.isValidName();
  }

  render() {
    var dialogActions = this.state.hasUnsavedChanges ? this.editedActions() : this.notEditedActions();

    if (this.state.saving) {
      dialogActions = this.savingActions();
    }

    var headTitle = this.state.isNew ? "Uusi toimiala" : "";
    var nameErrorText = (this.isValidName() || !this.state.editedNameOnce) ? "" : "Toimiala vaatii virallisen nimen";
    var idErrorText = (this.isValidId() || !this.state.editedIdOnce) ? "" : "Toimiala vaatii tunnistenumeron";
    return (
        <Dialog
        title={headTitle}
        actions={dialogActions}
        modal={true}
        open={this.props.enabled}>
        <TextField
            floatingLabelText="Tunnistenumero"
            value={this.state.category._id}
            disabled={!this.state.isNew}
            errorText={idErrorText}
            onChange={this.handleIdEdit}
            style={{width:"400px"}}
            /><br/>
          <TextField
            floatingLabelText="Virallinen nimi"
            multiLine={true}
            value={this.state.category.name}
            errorText={nameErrorText}
            onChange={this.handleNameEdit}
            style={{width:"400px"}}
            /><br />
          <TextField
            floatingLabelText="Epävirallinen nimi"
            multiLine={true}
            value={this.state.category.friendlyName}
            onChange={(event) => this.handleFriendlyNameEdit(event)}
            style={{width:"400px"}}
            /><br />
          <TextField
            floatingLabelText="Hakutermit"
            multiLine={true}
            value={this.state.category.searchTerms}
            onChange={this.handleSearchTermsEdit}
            style={{width:"400px"}}
            /><br/>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CategoriesPage/CategoryEditDialog.js